module.exports = __webpack_public_path__ + "static/service1-b41bd1ee8eff7708e26c5c5f41a52095.jpg";